import React from 'react'
import { FooterContainer, FooterLinksContainer, FooterLinksWrapper, FooterLinkItems, FooterLinkTitle, FooterLink, NavLink, WhatsappNavLink, FooterCopyWrapper, FooterLogo, WebsiteRights, SocialIcons, SocialIconLink, WhatsappIconLink } from './FooterElements'
import { FaWhatsapp, FaFacebook, FaInstagram } from 'react-icons/fa'
import { animateScroll as scroll } from 'react-scroll'

const Footer = () => {
    const toggleHome = () => {
        scroll.scrollToTop()
    }
    return (
        <FooterContainer>
            <FooterLinksContainer>
                <FooterLinksWrapper>
                    <FooterLinkItems>
                        <FooterLinkTitle>Quick links</FooterLinkTitle>
                        <FooterLink to="/frequent-questions">FAQs</FooterLink>
                        <FooterLink to="/payment-method">Payment methods</FooterLink>
                        <FooterLink to="/delivery-information">Delivery Informations</FooterLink>
                        <FooterLink to="/term-of-service">Terms of Service</FooterLink>
                        <FooterLink to="/privacy-policy">Privacy Policy</FooterLink>
                        <FooterLink to="/refund-policy">Refund Policy</FooterLink>
                    </FooterLinkItems>
                </FooterLinksWrapper>
                <FooterLinksWrapper>
                    <FooterLinkItems>
                        <FooterLinkTitle>#COXIBAKERY</FooterLinkTitle>
                        <NavLink href="mailto:withlove@coxibakery.com">Email: withlove@coxibakery.com</NavLink>
                        <WhatsappNavLink href="whatsapp://send?phone=60125968124" target="_blank" aria-label="Whatsapp">Whatsapp: +6012 285 1810 | +6012 596 8124</WhatsappNavLink>
                        <SocialIcons>
                            <SocialIconLink href="https://www.facebook.com/Coxibakery-%E5%BA%93%E8%AF%97%E3%81%AE%E5%B0%8F%E5%B1%8B-103930001646912" target="_blank" aria-label="Facebook" rel="noopener"><FaFacebook /></SocialIconLink>
                            <SocialIconLink href="https://www.instagram.com/coxibakery/" target="_blank" aria-label="Instagram" rel="noopener"><FaInstagram /></SocialIconLink>
                            <WhatsappIconLink href="whatsapp://send?phone=60125968124" target="_blank" aria-label="Whatsapp" rel="noopener"><FaWhatsapp /></WhatsappIconLink>
                        </SocialIcons>
                    </FooterLinkItems>
                </FooterLinksWrapper>
            </FooterLinksContainer>
            <FooterCopyWrapper>
                <FooterLogo to="/#" onClick={toggleHome}>
                    COXIBAKERY
                    </FooterLogo>
                <WebsiteRights>Copyright © {new Date().getFullYear()} COXIBAKERY. All Rights Reserved.
                    </WebsiteRights>
            </FooterCopyWrapper>
        </FooterContainer>
    )
}

export default Footer
